import React from "react";
import { Grid, Box, Typography} from "@mui/material";
import '../../App.css'

const Skillset = ({ data }) => {
  return (
    <Grid container rowGap={2} className="justify-content-center">
      {data.map((item) => {
        return (
          <Grid item xs={12} sm={6} id={item.title} className="text-align-center">
            <Typography variant="body1">{item.title}</Typography>
            <Box className="grid-item padding-top">
            {Object.entries(item.content).map(([key, value]) => {
                return (<Box>
                  {value}
                  <Typography variant="body2">{key}</Typography>
                  </Box>)
          })}
          </Box>
          </Grid>
        );
      })}
      </Grid>
  );
};

export default Skillset;